import {
  Button,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { User } from "../../../../app/slices/userSlice";
import { PointOfSales } from "../../../../app/slices/posSlice";
import Permission from "../../../../components/userPermission/userPermission";
import ConfirmationDialog from "../../../../helpers/ConfirmationDialog";

const getUserType = (_user) => {
  if (_user.is_representative) return "مندوب";
  else if (_user.is_j_rep) return "مندوب جملة";
  else if (_user.role === "pos")
    return `نقطة بيع : ${_user.pos_number ? `(${_user.pos_number})` : ""}`;
  else return "غير معرف";
};

// Shared between the "المعاملات المالية" and "مناقلات الدفع الالكتروني" tabs so
// both show the same user summary/actions.
const UserInfoCard = () => {
  const dispatch = useDispatch();
  const { user_id } = useParams();
  const user = useSelector((state) => state.user.user.form);

  const [openActive, setOpenActive] = useState(false);

  const handleConfirmActive = () => {
    setOpenActive(false);
    dispatch(
      User.WalletActivation({
        user_id: user.id,
        is_active: !user.wallet?.is_active,
      }),
    )
      .then(() => dispatch(User.getByIdData(user_id)))
      .catch(() => dispatch(User.getByIdData(user_id)));
  };

  return (
    <Card
      sx={{
        background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <ConfirmationDialog
        open={openActive}
        title="تاكيد"
        message={
          user.wallet?.is_active
            ? "هل انت متاكد من الغاء تفعيل المحفظة: "
            : "هل انت متاكد من تفعيل المحفظة :"
        }
        name={user.name}
        confirmText="تاكيد"
        cancelText="الغاء"
        onConfirm={() => handleConfirmActive()}
        onCancel={() => setOpenActive(false)}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack spacing={1.5}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#1976d2", mb: 1 }}
            >
              معلومات المستخدم
            </Typography>
            <Permission permission="pos_edit">
              <Button
                size="small"
                variant="contained"
                onClick={() => dispatch(PointOfSales.getById(user.pos_id))}
              >
                تعديل
              </Button>
            </Permission>
          </Stack>

          <Typography variant="body1" sx={{ color: "#1976d2" }}>
            <strong>الاسم:</strong> {user ? user.name : ""}
          </Typography>
          <Typography variant="body1" sx={{ color: "#1976d2" }}>
            <strong>رقم الهاتف:</strong> {user ? user.mobile : ""}
          </Typography>
          <Typography variant="body1" sx={{ color: "#1976d2" }}>
            <strong>نوع الحساب:</strong> {user ? getUserType(user) : ""}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body1" sx={{ color: "#1976d2" }}>
              <strong>حالة المحفظة:</strong>
            </Typography>
            <Chip
              label={user.wallet?.is_active ? "فعال" : "غير فعال"}
              color={user.wallet?.is_active ? "success" : "error"}
              size="small"
              onClick={() => setOpenActive(true)}
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default UserInfoCard;
